/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { RootState } from '../store';

export const autoSubmitSelector = (state: RootState) => state.settings.autoSubmit;

export const regionSelector = (state: RootState) => state.settings.region;
